import guiltSlice from "./guiltSlice";
const guiltActions = guiltSlice.actions;
export const { setAcceptGuilt, setAcceptTerms } = guiltActions;
